module.exports = __webpack_public_path__ + "static/media/0_2019_05_11.a8ef454d.jpg";